import React, { useState } from 'react'
import "../styles/login.css";
import Layout from '../components/Layout/Layout';
import { toast, Toaster } from 'react-hot-toast'; // Importing toast for success/error messages
import { Link, useNavigate } from 'react-router-dom';
import { text } from 'stream/consumers';
import { send } from 'process';
import axios from 'axios';

const ForgetPassword = () => {

    
  const navigate =  useNavigate();

//   const [otp, setOtp] = useState('');
//   const [newPassword, setNewPassword] = useState('');

  var otpSent = false; 
//   var otpSent = true; 
  var otpVerified = false; // Flag to check if OTP has been verified


  // State for storing the form data
  const [formData, setFormData] = useState({
    emailOrPhone: '',
    otp: '',
    newPassword: '',
  });


  const navigateToLogin = () => {
    navigate('/login'); // Redirect to signup page
  }
  







  // Handle input changes and update state
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const { emailOrPhone, otp, newPassword } = formData;

    // Basic validation before submitting
    if (!emailOrPhone || !otp || !newPassword) {
      toast.error('Please fill in all fields');
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_MODE === 'development' ? "http://localhost:8000/api/v1" : `${process.env.REACT_APP_API_URL}`}/auth/forgot-password`, 
        {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: emailOrPhone, otp: otp, newPassword: newPassword }), // Sending the form data
      });

      const result = await response.json();

      if (response.ok) {
       
        toast.success('Reset password successful');

        // You can redirect the user or handle post-login logic here (e.g., setting user token or navigation)
        // For example, redirect to a dashboard:
        window.location.href = '/login';
      } else {
        toast.error(result.message || 'Reset password failed');
      }
    } catch (error) {
      console.error('Error during login:', error);
      toast.error('An error occurred, please try again later');
    }
  };


    // Function to send OTP
      const sendOTP = async (e) => {
    e.preventDefault();
    const { emailOrPhone } = formData;
    try {
      const res = await axios.post(`${process.env.REACT_APP_MODE === 'development' ? "http://localhost:8000/api/v1" : `${process.env.REACT_APP_API_URL}`}/auth/send-otp`, {
        email: emailOrPhone
      });
      if (res && res.data.success) {
        toast.success(res.data.message);
        // this.props.history.push({
        //   pathname: '/otp-verification',
        //     state: email
        // })
        toast.success("Check your email for OTP");
        otpSent = true; // Set the flag to true when OTP is sent
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      // console.log(error);
      toast.error(error.response.data.message);
    }
  };





  return (
     <Layout title={"Lastbites: Reset Password"} description={undefined} keywords={undefined} author={undefined}>
      <main className="login">
        <div className="wrapper">
          <div className="title">
            <span style={{ textAlign: 'center' }}>Reset Your Password Here</span>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="row">
              <i className="fas fa-user" />
              <input
                type="text"
                placeholder="Email or Phone"
      
                name="emailOrPhone"
                value={formData.emailOrPhone}
                onChange={handleInputChange}
              />
            </div>
            {otpSent && (
              <>
                <div className="row">
                  <i className="fas fa-lock" />
                  <input
                    type="text"
                    placeholder="OTP"
                    name="otp"
                    value={formData.otp}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="row">
                  <i className="fas fa-lock" />
                  <input
                    type="password"
                    placeholder="New Password"
                    name="newPassword"
                    value={formData.newPassword}
                    onChange={handleInputChange}
                  />
                </div>
              </>
            )}
            {/* Conditionally render the OTP input and new password input if otpSent is true */}
            {/* <div className="row">
              <i className="fas fa-lock" />
              <input
                type="text"
                placeholder="OTP"
                name="otp"
                value={formData.otp}
                onChange={handleInputChange}
              />

            {/* <div className="pass">
              <a href="#">Forgot password?</a>
            </div> */}
            {!otpSent && (
            <div className="row button">
              <input className="inputOTP" value="Send otp" onClick={sendOTP} />
            </div>
            )}
            { otpSent && (
            <div className="row button">
              <input type="submit" value="Reset Password" />
            </div>

            )}
            <div className="signup-link">
              Not a member? <Link to={"/register"} className="cursor-pointer">Signup now</Link> 
            </div>
          </form>
        </div>
      </main>

      {/* Toast container for success/error messages */}
      <Toaster position="top-center" reverseOrder={false} />
    </Layout>
    
  )
}

export default ForgetPassword